<template>
  <div class="container">
    <modal class="modal"  :container-style="{ width: '400px', 'background-color': 'white' }" v-if="this.syncStatus !== 'idle'">
      <div class="modal-status">
        {{ $t('message.sync.' + syncStatus) }}
      </div>
      <div class="modal-progress" v-if="userParams.cacheInProgress && userParams.cacheInProgress  < 1 ">
        {{  Math.round(userParams.cacheInProgress, 2)  * 100 }} %
      </div>
      <div class="modal-progress" v-else-if="syncStatus === 'importing'">
        {{ $t('message.sync.geocodeWait') }}
      </div>
    </modal>
    <modal class="popup"
      :container-style="{ width: '400px', 'background-color': 'white' }"
      v-if="this.syncStatus === 'idle' && isMapReady && customersDataReady && userParams.limitReached && showPopup"
    >
      <div v-on:click="showPopup = false">
        <Popup/>
      </div>
    </modal>
    <toolbar v-model="currentTool"/>
    <div class="map-content" v-if="currentTool === 'customers'">
      <div v-if="isMapReady && customersDataReady" class="map-content-panel  customers-panel">
        <div class="top-border"/>
        <stats-list class="map-stats"  :items="statsList"/>
      </div>
      <div class="map-content-panel info-panel"></div>
      <Map ref="mapContainer" :customersSource="customersGeoJSON" @loaded="mapLoaded" @idle="mapIdle"/>
    </div>
    <div class="stats-content" v-if="currentTool === 'stats'">
      stat tab
    </div>
  </div>
</template>
<script>
import Popup from '../components/LimitWarningPopup'
import Modal from '../components/ModalContainer'
import Toolbar from '../components/Toolbar'
import Map from '../components/Map'
import StatsList from '../components/StatsList'
import { mapGetters, mapState } from 'vuex'
export default {
  components: {
    Modal,
    Toolbar,
    Map,
    StatsList,
    Popup
  },
  async mounted () {
  },
  data () {
    return {
      currentTool: 'customers',
      isMapReady: false,
      showPopup: true
    }
  },
  computed: {
    ...mapState('synchro', ['syncStatus']),
    ...mapState('customers', { customersGeoJSON: state => state.data, customersDataReady: state => state.dataReady }),
    ...mapState('user', { userType: state => state.type, userParams: state => state.params }),
    ...mapGetters('customers', ['statsList']),
    ...mapGetters('synchro', ['isRecentlySync'])
  },
  watch: {
    userParams: {
      deep: true,
      async handler (newParams, oldParams) {
        // TODO: add params to compare to see if loadData is necessary
        if (this.userParams.customersDataset && this.isMapReady) {
          await this.$store.dispatch('customers/loadData')
          await this.$store.dispatch('customers/reloadStats', this.$refs.mapContainer.map.getBounds())
        }
      }
    }
  },
  methods: {
    resizeMap () {
      this.$refs.mapContainer.map.resize()
    },
    async mapLoaded () {
      if (!this.isRecentlySync) {
        await this.$store.dispatch('synchro/syncCustomers')
      }
      await this.$store.dispatch('customers/loadData')
      const creditsRemaining = await this.$store.state.user.params.creditsRemaining
      if (!creditsRemaining) {
        window.alert(this.$t('message.creditLimitReached.generic'))
      }
    },
    mapIdle () {
      if (this.customersDataReady) {
        this.$store.dispatch('customers/reloadStats', this.$refs.mapContainer.map.getBounds())
      }
      this.isMapReady = true
    }
  }
}
</script>

<style lang="scss">
.modal {
  &-progress {
      font-family: 'geomanist-medium';
      font-size: 1.25rem;
      font-weight: 500;
      letter-spacing: 0.17px;
      color: #5a5a65;
      height: 20px;
    }
    &-status {
      font-family: 'geomanist-book';
      font-size: 1rem;
      letter-spacing: 0.11px;
      color: #a7a7a7;
      margin-bottom: 16px;
    }
  &-popup {
      font-family: 'geomanist-medium';
      font-size: 1.15rem;
      font-weight: 500;
      letter-spacing: 0.17px;
      color: #5a5a65;
      height: 60px;
      margin-bottom: 16px;
    }
}
.map-stats {
  margin-top: 35px;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .stat {
    margin: 0;
    margin-bottom: 25px;
    display: flex;
    flex-direction: column-reverse;
    padding: 0;
    &-value {
      font-family: 'geomanist-medium';
      font-size: 1.5rem;
      font-weight: 500;
      letter-spacing: 0.17px;
      color: #5a5a65;
    }
    &-description {
      font-family: 'geomanist-book';
      font-size: 0.9375rem;
      letter-spacing: 0.11px;
      color: #a7a7a7;
      margin-bottom: 2px;
    }
}
}
.container {
  display: flex;
  width: 100vw;
  height: calc(100vh - 72px);
  background-color: #20212C;
  .map-content {
    position: relative;
    display: flex;
    width: calc(100vw - 72px);
    .map-content-panel {
      z-index: 1000;
      border-radius: 3px;
      box-shadow: 0 2px 15px -7px rgba(0, 0, 0, 0.24);
      background-color: white;
    }
    .customers-panel {
      position: absolute;
      top: 50px;
      left: 50px;
      width: 182px;
      .top-border {
        width: 182px;
        height: 5px;
        border-radius: 2.5px;
        background-color: #ff5a50;
      }
   }
  }
  .stats-content {
    background-color: white;
    color: black;
    width: 100%;
    text-align: center;
  }
}
</style>
